import { Component, OnInit, ViewChild } from '@angular/core';
import { EditorComponent } from '../../../base/editor/editor.component';
import { HistoryComponent } from '../../../fragments/history/history.component';
import { AppService } from '../../../../services/app.service';
import { EmailMessageService } from '../../../../services/email-messages/email-message.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { EmailMessageEnvelope } from '../../../../models/net/envelope/email-message-envelope';

@Component({
    selector: 'app-email-message',
    templateUrl: './email-message.component.html',
    styleUrls: ['./email-message.component.css', '../../../../app.component.css']
})

export class EmailMessageComponent extends EditorComponent {

    public ccBccDivDynamicClassName: string = "expanding-div-collapsed";
    public ccBccToggleButtonDynamicIconName: string = "keyboard_double_arrow_down";

    @ViewChild("appHistory") appHistory!: HistoryComponent;
    //@ViewChild("fromChipSelector") fromChipSelector!: ChipSelectorComponent;

    public constructor(public override appService: AppService,
                       public override itemService: EmailMessageService,
                       public override route: ActivatedRoute,
                       public override location: Location) {

        super(appService, itemService, route, location, "emailmessage", "emailmessages");
    }

    public override initializeEnvelope = (envelope: EmailMessageEnvelope | null): void => {

        super.initializeEnvelope(envelope);

        this.itemEnvelope = new EmailMessageEnvelope(envelope);
        this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);

        if (this.itemEnvelope?.Document.Item.Body === null || this.itemEnvelope?.Document.Item.Body === undefined) {

            this.itemEnvelope!.Document.Item.Body = "";
        }
    }

    public ngAfterViewInit(): void {

        //this.toChipSelector.itemAdded.subscribe((item: AvatarPrimitive) => {

        //    this.toContactIds.push(item.Id);
        //    this.addMessageContactToMessage(item.Id, 1);
        //});
    }

    public toggleCcBccFieldVisibility = (): void => {

        this.ccBccDivDynamicClassName = this.ccBccDivDynamicClassName == "expanding-div-collapsed" ? "expanding-div-expanded" : "expanding-div-collapsed";
        this.ccBccToggleButtonDynamicIconName = this.ccBccToggleButtonDynamicIconName == "keyboard_double_arrow_up" ? "keyboard_double_arrow_down" : "keyboard_double_arrow_up";
    }
}
